import View from 'ln/view/View';

import {Toggle} from './Toggle';

export class ToggleView extends View<Toggle> {

    private readonly checkedTemplate_: string;
    private readonly uncheckedTemplate_: string;

    public constructor(checkedTemplate: string, uncheckedTemplate: string) {
        super({ template: `<span class="Toggle"></span>`, data: new Toggle() });
        this.checkedTemplate_ = checkedTemplate;
        this.uncheckedTemplate_ = uncheckedTemplate;
    }

    protected init() {
        this.data.change.filter(ch => ch.name === 'checked')
                        .subscribe(_ => this.updateIcon());
        this.updateIcon();
    }

    private updateIcon(): void {
        if (!this.node || !this.data) return;
        this.node.innerHTML = this.data.checked ? this.checkedTemplate_
                                                : this.uncheckedTemplate_;
    }
}
